import { Component, OnInit } from '@angular/core';
import {FormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {matchFieldsValidator} from '../../helper/validators/match.validator';
import {Observable, Subscription} from 'rxjs';
import {Store} from '@ngrx/store';

import * as fromUser from '../store/user.reducers';
import * as fromApp from '../../store/app.reducers';
import * as UserActions from '../store/user.actions';
import {Cookie} from '../../helper/cookie';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'app-user-edit-password',
    templateUrl: './user-edit-password.component.html',
    styleUrls: ['./user-edit-password.component.scss'],
    standalone: false
})
export class UserEditPasswordComponent implements OnInit {

  userState: Observable<fromUser.State>;
  userSubscription: Subscription;
  userEditPasswordForm: UntypedFormGroup;
  userId: number;
  cookies: Cookie;

  constructor(
    public store: Store<fromApp.AppState>,
    public notifierService: ToastrService
  ) {
    this.cookies = new Cookie();
    this.initEditPasswordForm();
  }

  ngOnInit() {
    this.userState = this.store.select('user');
    if (this.cookies.getCookie('auditor-user-id')) {
      this.userId = +this.cookies.getCookie('auditor-user-id');
    }
  }

  onSubmit() {
    const data = this.userEditPasswordForm.value;
    if (this.userEditPasswordForm.valid) {
      this.store.dispatch(
        new UserActions.ChangeUser({
          id: this.userId,
          params: data,
          config: {}
        })
      );
    } else {
      this.notifierService.warning('Fill the form correctly');
    }
  }

  initEditPasswordForm() {
    this.userEditPasswordForm = new UntypedFormGroup({
      'password': new FormControl(null, [Validators.required, Validators.pattern(/(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).{7,}/)]),
      'retyped_password': new FormControl(null, [Validators.required])
    }, [
      matchFieldsValidator('password', 'retyped_password')
    ]);
  }

}
